import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.trim.js";

/**
 * 主题色映射
 * @description 定义各 AppName 的主题色令牌集合与映射关系
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

export var DEFAULT_THEME_NAME = 'jojo'; // 通用色（基于 Figma 灰色色阶，各主题共享）

var commonTheme = {
  colorSurface: '#FFFFFF',
  colorTitle: '#404040',
  colorTextMain: '#2B323C',
  colorTextSecondary: '#41474F',
  colorTextPlaceholder: '#B2B2B2',
  colorTextWeak: '#ACB2BB',
  colorTextDisabled: '#E0DFDF',
  colorTextAction: '#666666',
  colorBorder: '#E0DFDF'
}; // jojo 主题（黄，Figma node-id=301-1309）

var jojoTheme = __assign(__assign({}, commonTheme), {
  color_1: '#FCF9DE',
  color_2: '#FCF3BA',
  color_3: '#FFEB6B',
  color_4: '#FCDA00',
  color_5: '#DBAF00',
  color_6: '#544300',
  buttonTextColor: '#544300',
  buttonBackgroundColor: '#FCDA00',
  buttonActiveBackgroundColor: '#F2CC35',
  buttonBorderRadius: '60px',
  buttonBorder: 'none',
  buttonBoxShadow: 'none',
  buttonDisabledTextColor: '#B2B2B2',
  buttonDisabledBackgroundColor: '#F5F4F4',
  buttonDisabledBorder: 'none',
  buttonSecondaryBackgroundColor: '#FFFFFF',
  buttonSecondaryText: '#544300',
  buttonSecondaryBorder: '2px solid #FCDA00',
  buttonSecondaryActiveBackgroundColor: '#FFFCF2',
  buttonTertiaryBackgroundColor: '#FFFFFF',
  buttonTertiaryText: '#666666',
  buttonTertiaryActiveBackgroundColor: '#F5F4F4',
  buttonTertiaryActiveText: '#404040'
}); // jojoup 主题（棕，Figma node-id=19624-34307）


var jojoupTheme = __assign(__assign({}, commonTheme), {
  color_1: '#FEF7E5',
  color_2: '#F0DCC2',
  color_3: '#E0BF94',
  color_4: '#C09660',
  color_5: '#986C31',
  color_6: '#664314',
  buttonTextColor: '#544300',
  buttonBackgroundColor: '#FCDA00',
  // 无点击态，省略 buttonActiveBackgroundColor
  buttonBorderRadius: '20px',
  buttonBorder: '2px solid #986C31',
  buttonBoxShadow: 'inset 0px -8px 0px 0px rgba(0, 0, 0, 0.12)',
  buttonDisabledTextColor: '#664314',
  buttonDisabledBackgroundColor: '#FAE9D2',
  buttonDisabledBorder: '2px solid #E0BF94',
  buttonSecondaryBackgroundColor: '#FEF7E5',
  buttonSecondaryText: '#664314',
  buttonSecondaryBorder: '2px solid #986C31',
  buttonSecondaryBoxShadow: 'inset 0px -8px 0px 0px rgba(0, 0, 0, 0.08)',
  buttonTertiaryBackgroundColor: '#FFFFFF',
  buttonTertiaryText: '#666666'
}); // matrix 主题（蓝，Figma node-id=1599-12625）


var matrixTheme = __assign(__assign({}, commonTheme), {
  color_1: '#EBF9FF',
  color_2: '#DBF3FF',
  color_3: '#87D7FF',
  color_4: '#33BBFF',
  color_5: '#0090D9',
  color_6: '#0C567A',
  buttonTextColor: '#FFFFFF',
  buttonBackgroundColor: '#33BBFF',
  buttonActiveBackgroundColor: '#0090D9',
  buttonBorderRadius: '60px',
  buttonBorder: 'none',
  buttonBoxShadow: 'none',
  buttonDisabledTextColor: '#B2B2B2',
  buttonDisabledBackgroundColor: '#F5F4F4',
  buttonDisabledBorder: 'none',
  buttonSecondaryBackgroundColor: '#FFFFFF',
  buttonSecondaryText: '#0090D9',
  buttonSecondaryBorder: '2px solid #33BBFF',
  buttonSecondaryActiveBackgroundColor: '#FFFCF2',
  buttonTertiaryBackgroundColor: '#FFFFFF',
  buttonTertiaryText: '#666666',
  buttonTertiaryActiveBackgroundColor: '#F5F4F4',
  buttonTertiaryActiveText: '#404040'
}); // zzx 主题（蓝，与 matrix 共享色系和按钮规范）


var zzxTheme = __assign({}, matrixTheme); // beans 主题（绿，Figma node-id=48-2043）


var beansTheme = __assign(__assign({}, commonTheme), {
  color_1: '#EFFAEB',
  color_2: '#D2F7C6',
  color_3: '#A0D98D',
  color_4: '#5DC43B',
  color_5: '#4AA12D',
  color_6: '#155200',
  buttonTextColor: '#FFFFFF',
  buttonBackgroundColor: '#5DC43B',
  buttonActiveBackgroundColor: '#4AA12D',
  buttonBorderRadius: '20px',
  buttonBorder: '4px solid #4AA12D',
  buttonBoxShadow: 'none',
  buttonDisabledTextColor: '#B2B2B2',
  buttonDisabledBackgroundColor: '#F5F4F4',
  buttonDisabledBorder: 'none',
  buttonSecondaryBackgroundColor: '#FFFFFF',
  buttonSecondaryText: '#155200',
  buttonSecondaryBorder: '2px solid #4AA12D',
  buttonSecondaryActiveBackgroundColor: '#EFFAEB'
}); // doudou 主题（绿，与 beans 共享色系和按钮规范）


var doudouTheme = __assign({}, beansTheme);

export var themeMap = {
  jojo: jojoTheme,
  jojoup: jojoupTheme,
  matrix: matrixTheme,
  beans: beansTheme,
  doudou: doudouTheme,
  zzx: zzxTheme
};
export var appThemeNameMap = {
  jojo: 'jojo',
  jojoup: 'jojoup',
  matrix: 'matrix',
  beans: 'beans',
  doudou: 'doudou',
  zzx: 'zzx'
};
/**
 * 根据 AppName 解析主题名
 * @param appName 应用标识（可空，会先 trim().toLowerCase() 归一化）
 * @returns 对应的 ThemeName，未注册时回退默认主题
 */

export function resolveThemeName(appName) {
  var normalized = appName === null || appName === void 0 ? void 0 : appName.trim().toLowerCase();

  if (!normalized) {
    return DEFAULT_THEME_NAME;
  }

  return appThemeNameMap[normalized] || DEFAULT_THEME_NAME;
}
/**
 * 根据 AppName 获取主题令牌
 * @param appName 应用标识（可空）
 * @returns 对应的 ThemeTokens，未注册时返回默认主题
 */

export function getThemeTokens(appName) {
  var themeName = resolveThemeName(appName);
  return themeMap[themeName];
}